import defined from "../Core/defined.js";
import RequestType from "../Core/RequestType.js";
import createTaskProcessorWorker from "./createTaskProcessorWorker.js";
import EV_IndexedDBProvider from "../EMExtensions/EV_IndexedDBProvider.js";

var iDBprovider = undefined;

function downloadErrorFormIdbCallback(cesium3DTilePack) {
  //计算indexeddb加载数据时间
  //var now2 = new Date();
  //var expendTime = now2.getTime() - cesium3DTileData.requestTime;
  //console.log('Error: '+cesium3DTileData.keyName +'  '+ expendTime+ ' ms');

  var postMessage = self.webkitPostMessage || self.postMessage;
  try {
    postMessage({
      workerType: RequestType.TILES3D,
      dataName: cesium3DTilePack.keyName,
      workerTaskID: cesium3DTilePack.workerTaskID,
      data: undefined,
      meshPrimitives: []
    });
  } catch (e) {
    postMessage({});
  }
}

function downloadSuccessFormIdbCallback(cesium3DTilePack, data) {
  //计算indexeddb加载数据时间
  var now2 = new Date();
  var expendTime = now2.getTime() - cesium3DTilePack.requestTime;
  //console.log('workerLoadSuccess: '+cesium3DTileData.keyName +'  '+ expendTime+ ' ms ');

  var postMessage = self.webkitPostMessage || self.postMessage;
  try {
    // transfer the test array back to the caller
    postMessage({
      workerType: RequestType.TILES3D,
      dataName: cesium3DTilePack.keyName,
      workerTaskID: cesium3DTilePack.workerTaskID,
      data: data,
      meshPrimitives: cesium3DTilePack.meshPrimitives
    });
  } catch (e) {
    postMessage({});
  }
}

function create3DTileArraybuffer(parameters, transferableObjects) {
  var indexedDB = parameters.indexedDB;
  var c3DTilePack = parameters.taskData;
  c3DTilePack.workerTaskID = parameters.workerTaskID;
  if (!defined(iDBprovider)) {
    iDBprovider = new EV_IndexedDBProvider(indexedDB);
    iDBprovider.createIDB("EVIDB", 1, ["model", "imagery", "terrain", "3DTile"]);
    downloadErrorFormIdbCallback(c3DTilePack);
  } else {
    if (defined(iDBprovider.iDB)) {
      var now = new Date();
      c3DTilePack.requestTime = now.getTime();
      //console.log('loadRequest: '+c3DTileData.keyName +'  '+now);
      iDBprovider.download3DTileArrayBuffer("EVIDB", 1, "3DTile", c3DTilePack, downloadErrorFormIdbCallback,
        downloadSuccessFormIdbCallback);
    } else {
      downloadErrorFormIdbCallback(c3DTilePack);
    }

  }
}

export default createTaskProcessorWorker(
  create3DTileArraybuffer
);
